import React from 'react'
import style from './Quiz.module.css';
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'
import Button from '../../components/Button/Button';
import emoji_fest from '../../assets/emoji-fest.png';
import party from "party-js";
import { QuestionCard, PDF } from '../../components';
import clock from '../../assets/clock.png';
import moment from 'moment';
import 'moment/locale/es'

const Quiz = ({nameToDisplay, propsQuestions}) => {

    const location = useLocation();
    // const { questions } = location.state;

    const [questions, setQuestions] = useState(propsQuestions);

    const [isOpen, setIsOpen] = useState(false);
    const [buttonStatus, setButtonStatus] = useState(false);
    const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(0);
	const [showScore, setShowScore] = useState(false);
	const [score, setScore] = useState(0);
    const [counter, setCounter] = useState(45);

    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;

    const [shuffledAnswers, setShuffledAnswers] = useState([])

    const player = [{
        name: nameToDisplay,
        score: score,
        date: date
    }]

    const confettiSettings = {
        shapes: [
            "square",
            "rectangle"
        ],
        count: party.variation.range(200, 200),
        spread: 30,
        speed: party.variation.range(500, 200),
        size: party.variation.skew(1.2, 0.8),
        rotation: () => party.random.randomUnitVector().scale(360),
        color: () =>
            party.random.pick([
            party.Color.fromHex("#E02F5D"),
            party.Color.fromHex("#5F2CE7"),
            party.Color.fromHex("#5BE096"),
            party.Color.fromHex("#5777EA")
            ])
    };

    useEffect(() => {
        setShuffledAnswers(shuffle(questions[currentQuestion]?.answerOptions));
    }, [currentQuestion])

    useEffect(() => {
        if (isOpen) {
            party.confetti(document.getElementById("confetti"), confettiSettings);
        }
    }, [isOpen]);

    useEffect(() => {
        if (counter > 0 && !buttonStatus) {
            setTimeout(() => {
                setCounter(counter - 1)
            }, 1000)
        }
        if (counter === 0) {
            setButtonStatus(true);
            setShowCorrectAnswer(true);
        }
    }, [counter])

	const handleAnswerOptionClick = (isCorrect) => {
		if (isCorrect) {
			setScore(score + counter);
		} 
        setShowCorrectAnswer(true);
        setButtonStatus(true);
	};

    const nextQuestion = () => {
        const nextQuestion = currentQuestion + 1;
		if (nextQuestion < questions?.length) {
			setCurrentQuestion(nextQuestion);
            setButtonStatus(false);
            setShowCorrectAnswer(false);
            setCounter(45);
		} else {
            localStorage.setItem('score', JSON.stringify(score));
			setShowScore(true);
            setIsOpen(true);
            savePlayer()
		}
    }

    const shuffle = (array) => {
        let currentIndex = array?.length, randomIndex;
        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }
        return array;
    }

    const confetti = () => {
        setIsOpen(!isOpen);
    }

    const savePlayer = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(...player)
        };

        fetch('https://quiz-laura-default-rtdb.firebaseio.com/players-joaquin.json', requestOptions)
        .then(response => response.json())
    };

    return (
        <div className={style.container}>
            {showScore ? (
				<div className={style.score_section} id='confetti'>
                    <p className={style.score_title}>{player[0].name}, tu puntaje fue de:</p>
                    <p className={style.score}>{score} puntos</p>
                    <img className={style.emoji} src={emoji_fest} alt="emoji" onClick={confetti}/>

                    <div className={style.links}>
                        <PDF name={player[0].name} score={score} date={moment().locale('es').format('LL')}/>  
                        <Link to='/ranking' className={style.go_to_ranking}>
                            <Button text='Ir al ranking'/>
                        </Link>
                    </div>
				</div>
			) : (
                <>
                    <h1 className={style.question}>{questions[currentQuestion]?.questionText}</h1>
                    
                    <div className={style.timer}>
                        <img className={style.clock} src={clock} alt="" />
                        <p>00:{counter < 10 ? '0' + counter : counter}''</p>
                    </div>
                    
                    <div className={style.answer_container}>
                        {shuffledAnswers?.map((answerOption, index) => (
                            <QuestionCard
                                key={index}  
                                text={answerOption.answerText} 
                                onClick={() => handleAnswerOptionClick(answerOption.isCorrect)}
                                isCorrect={answerOption.isCorrect}
                                showCorrectAnswer={showCorrectAnswer}
                                disabled={buttonStatus}
                            />
                        ))}
                    </div>

                    <Button text='Siguiente' onClick={buttonStatus ? nextQuestion : null} disabled={!buttonStatus}/> 
                </>
            )}
        </div>
    )
}

export default Quiz